import {createAction} from "@reduxjs/toolkit";
import {ExceedsNonPrimaryVolumeStatisticsSearchCriteria} from "@ots-frontend/ots-data";

export const setExceedsNonPrimaryVolumeStatisticsSearchPageFilter = createAction<ExceedsNonPrimaryVolumeStatisticsSearchCriteria>("ui/exceeds-non-primary-volume-statistics-search-page/setFilter");
